"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _Icons = require("../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CloseIconButton = (0, _styledComponents.default)(_Icons.CancelIcon).withConfig({
  displayName: "CloseIconButton",
  componentId: "sc-19wgu2s-0"
})(["position:absolute;top:1.5rem;right:1.5rem;z-index:100;font-size:1.5rem;cursor:pointer;opacity:0.7;&:hover{opacity:1;}"]);

var DialogTitleContainer = _styledComponents.default.div.withConfig({
  displayName: "DialogTitleContainer",
  componentId: "sc-19wgu2s-1"
})(["padding:", ";"], (0, _helpers.getSpacing)('xlarge'));

var DialogTitle = function DialogTitle(_ref) {
  var onClose = _ref.onClose,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["onClose", "children"]);

  return _react.default.createElement(DialogTitleContainer, rest, children, onClose && _react.default.createElement(CloseIconButton, {
    onClick: onClose
  }));
};

exports.DialogTitle = DialogTitle;